export const selectLingoLiftAuthParamsFromDomObject = (object: HTMLElement) => {
  const url = JSON.parse(object.dataset.url ?? '');
  const error = JSON.parse(object.dataset.errorMessages ?? '');
  const recaptchaSiteKey = object.dataset.recaptchaSitekey ? JSON.parse(object.dataset.recaptchaSitekey ?? '') : '';
  const inputs = JSON.parse(object.dataset.inputs ?? '');
  const googleUrl = object.dataset.googleUrl ?? '';
  const googleQueryWho = object.dataset.googleQueryWho ?? '';
  const googleQueryInviteToken = object.dataset.googleQueryInviteToken ?? '';
  const googleQueryEnrollSchoolTrial = object.dataset.googleQueryEnrollSchoolTrial === 'true';
  const googleAlt = object.dataset.googleAlt ?? '';
  const cleverUrl = object.dataset.cleverUrl ?? '';
  const cleverQueryType = object.dataset.cleverQueryType ?? '';
  const cleverQueryInviteToken = object.dataset.cleverQueryInviteToken ?? '';
  const cleverQueryEnrollSchoolTrial = object.dataset.cleverQueryEnrollSchoolTrial === 'true';
  const cleverAlt = object.dataset.cleverAlt ?? '';
  const contactUsUrl = object.dataset.contactUsUrl ?? '';
  const startFreeTrialUrl = object.dataset.startFreeTrialUrl ?? '';
  const signUpUrl = object.dataset.signUpUrl ?? '';
  const forgotPasswordUrl = object.dataset.forgotPasswordUrl ?? '';
  const notice = JSON.parse(object.dataset.notice ?? '');
  const inviteToken = object.dataset.inviteToken ?? '';
  const enrollSchoolTrial = object.dataset.enrollSchoolTrial === 'true';
  const nycpsUrl = object.dataset.nycpsUrl || '';
  const nycpsQueryWho = object.dataset.nycpsQueryWho ?? '';
  const nycpsAlt = object.dataset.nycpsAlt || '';

  return {
    url,
    error,
    inputs,
    recaptchaSiteKey,
    googleUrl,
    googleQueryWho,
    googleQueryInviteToken,
    googleQueryEnrollSchoolTrial,
    googleAlt,
    cleverUrl,
    cleverQueryType,
    cleverQueryInviteToken,
    cleverQueryEnrollSchoolTrial,
    cleverAlt,
    contactUsUrl,
    startFreeTrialUrl,
    signUpUrl,
    forgotPasswordUrl,
    notice,
    inviteToken,
    enrollSchoolTrial,
    nycpsUrl,
    nycpsQueryWho,
    nycpsAlt,
  };
};

